
<div *ngIf="question.verses">
    <div *ngIf="!profile?.anonymous && !!profile?.uid" class="askButton button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</div>
      <div class="regularText greyText emobile" >
        <div class="r180">
          <h3>&#10162;</h3>
        </div>
        <h6>&nbsp;&nbsp;{{config?.questionTemplateExplore}}</h6>
      </div>
     <h3 *ngIf="!profile?.anonymous && !!profile?.uid" class="askButtonMobile button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</h3>
  </div>

  <div *ngIf="!question.verses">
      <div class="noVerseButtons" *ngIf="!!profile">
          <div   *ngIf="question.questionID !== '19' && question.lessonID !== '8'"  class="askButton button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</div>
          <h3   *ngIf="question.questionID !== '19' && question.lessonID !== '8'"  class="askButtonMobile button" (click)="openStudentQuestion()">{{config?.questionTemplateGotQuestion}}</h3>
          <div *ngIf="question.questionID === '19' && question.lessonID === '8'" class="askButton button pulse" (click)="openStudentQuestion()">{{config?.questionTemplateChurch}}</div>
          <h3  *ngIf="question.questionID === '19' && question.lessonID === '8'" class="askButtonMobile button pulse" (click)="openStudentQuestion()">{{config?.questionTemplateChurch}}</h3>
      </div>
  </div>

<!-- Contact Component -->
    <div *ngIf="userQuestion === 'show' && !( question?.questionID === '19' && question?.lessonID === '8')" class="QuestionBackdrop" [@userQuestion]="userQuestion" >
      <form (ngSubmit)="submitStudentQuestion($event)"  class="QuestionBorder">
        <div class="btnctn"><span class="closebtn" (click)="closeStudentQuestion()">&times;</span></div> <br>
        <h1 class="regularText whiteText " style="display: block; text-align: center">{{config?.questionTemplateAsk}}</h1>
        <h6 class="regularText whiteText userQuestionFormatter" style="display: block; text-align: left">{{config?.questionTemplateQuestion}}</h6>
        <textarea
          class="message"
          name="moreinfo"
          cols="60"
          rows="10"
          placeholder="Please allow up to 3 days for a response." 
          required="required" 
          [(ngModel)]="questionMessage"
        >
        </textarea><br>
        <button class="buttonConfig button" >{{config?.questionTemplateSubmit}}</button>
        <h3 class="regularText whiteText" style="text-align: center;" >{{questionError}}</h3>
      </form>
  </div>